import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib';
import { createSlice } from '@reduxjs/toolkit';

export const settingsUiSlice = createSlice({
  name: 'settings-ui',
  initialState: baseUiInitialState,
  reducers: {
    ...baseUiReducers,
  },
});
